'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendBrowserNotification = sendBrowserNotification;
exports.sendNewMessageNotification = sendNewMessageNotification;
exports.sendNewEmailNotification = sendNewEmailNotification;
exports.sendAssignmentNotification = sendAssignmentNotification;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _underscore = require('underscore');

var _images = require('../assets/images');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLOSE_AFTER_MS = 5000;

function getNotificationTitle(user, titleType) {
  var identifier = void 0;
  if (!user.firstName) {
    identifier = _I18n2.default.text('conversationsUI.notifications.unknownVisitor');
  } else {
    identifier = _I18n2.default.SafeString((0, _underscore.compact)([user.firstName, user.lastName]).join(' ') || user.email);
  }

  return _I18n2.default.text('conversationsUI.notifications.' + titleType, {
    identifier: identifier
  });
}

function getOptions(channel, visitor, text) {
  var avatar = visitor.vid ? visitor.avatar : null;
  var defaultText = _I18n2.default.text('conversationsUI.notifications.pushText');
  return {
    body: text || defaultText,
    icon: avatar || _images.defaultNotificationAvatar,
    tag: '' + channel,
    silent: true
  };
}

function sendBrowserNotification(title, options, onClick) {
  if (!('Notification' in window)) {
    // Not supported in this browser.
    return;
  } else if (window.Notification.permission !== 'denied') {
    window.Notification.requestPermission(function (result) {
      if (result === 'denied') return;
      var notification = new window.Notification(title, options);

      notification.onclick = function () {
        window.focus();
        onClick();
      };

      setTimeout(function () {
        notification.close();
      }, CLOSE_AFTER_MS);
    });
  }
}

function sendNewMessageNotification(channel, visitor, text, onClick) {
  var title = getNotificationTitle(visitor, 'newMessage');
  var options = getOptions(channel, visitor, text);
  sendBrowserNotification(title, options, onClick);
}

function sendNewEmailNotification(channel, visitor, text, onClick) {
  var title = getNotificationTitle(visitor, 'newEmail');
  var options = getOptions(channel, visitor, text);
  sendBrowserNotification(title, options, onClick);
}

function sendAssignmentNotification(channel, responder, text, onClick) {
  var title = getNotificationTitle(responder, 'assignment');
  var options = getOptions(channel, responder, text);
  sendBrowserNotification(title, options, onClick);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/notifications/sendBrowserNotification.js
// module id = 606
// module chunks = 2 3